






















































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { IContractProduct } from "@/models/contracts";
import { IStatus } from "@/models/statuses";
import { Location } from "vue-router";
import { IClient } from "@/models/clients";
import CProdMixin from "@/mixins/cProdMixin";
import Context from "@/mixins/context";
import { ProductCategoryTypes as PCT } from "@/data/enums/products";
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "cprod-status-summary": () =>
      import("@/components/app/global/contractProducts/cProdStatusSummary.vue"),
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  }
})
export default class CProdWellLink extends Mixins(CProdMixin, Context) {
  // Props

  @Prop({ required: true })
  public readonly cProd!: IContractProduct;

  @Prop({ default: null })
  public readonly clientId!: IClient["id"];

  @Prop({ default: "router-link" })
  public readonly tag!: string;

  @Prop({ default: () => null })
  public readonly props!: string;

  // Computed

  public get isActive() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/isActive`
    ](this.cProd);
  }

  public get isSubscription() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/isSubscription`
    ](this.cProd);
  }

  public get hasAutoExpireEnabled() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/hasAutoExpireEnabled`
    ](this.cProd);
  }

  public get hasAutoRenewDisabled() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/hasAutoRenewDisabled`
    ](this.cProd);
  }

  public get mappedStatus() {
    const mapping = this.getMappedStatus(this.cProd.status as IStatus);
    if (this.isSubscription && this.isActive) {
      if (this.hasAutoExpireEnabled) {
        return {
          ...mapping,
          name: this.$t("_.active_expires_soon"),
          type: "is-danger",
          icon: "exclamation-circle"
        };
      } else if (this.hasAutoRenewDisabled) {
        return {
          ...mapping,
          name: this.$t("_.active_auto_renew_disabled"),
          type: "is-warning",
          icon: "exclamation-circle"
        };
      }
    }
    return mapping;
  }

  public get mainProductId() {
    if (
      [PCT.PRODUCT_OPTION, PCT.PRODUCT_ATTRIBUTE].includes(
        this.cProd.product?.category?.category_type as PCT
      )
    )
      return this.cProd.main_contracts_product_id;
    else return this.cProd.id;
  }

  public get cProdRoute(): Location {
    return {
      name: this.isAdmin
        ? "admin__clientCProd"
        : this.isMockClientContext
        ? "admin__upmindClientCProd"
        : "clientCProd",
      params: {
        ...(this.isAdmin && this.clientId ? { clientId: this.clientId } : {}),
        contractId: this.cProd.contract_id,
        productId: this.mainProductId as string
      }
    };
  }
}
